import { Box, Typography } from "@mui/material";

const styles = {
    critical: {
        backgroundColor: '#FFE4E4',
        textColor: '#B50500',
        label: 'Critical'
    },
    'high severity': {
        backgroundColor: '#FFE9DB',
        textColor: '#FF6B0F',
        label: 'High Severity'
    },
    warning: {
        backgroundColor: '#FFF4CF',
        textColor: '#C79201',
        label: 'Warning'
    },
    default: {
        backgroundColor: '#FFF4CF',
        textColor: '#C79201',
        label: null
    },
}

const SeverityBadge = ({ severity, count = null }) => {

    const severityValue = severity?.toLowerCase()?.trim();
    const severityKey = Object.keys(styles).includes(severityValue) ? severityValue : 'default';
    const textColor = styles[severityKey]['textColor'];
    const backgroundColor = styles[severityKey]['backgroundColor'];
    let label = styles[severityKey]['label'] || severity;

    if (count) {
        label = `${count} ${label}`
    }

    return (
        <Box
            sx={{
                borderRadius: '4px',
                px: 1.5,
                py: 0.25,
                bgcolor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Typography variant="fw600s12c8D8D8D" sx={{color: textColor, lineHeight: '20px'}}>
                {label}
            </Typography>
        </Box>
    )
}

export default SeverityBadge;
